(function () {
  'use strict';

  var GIFT_VARIANT_ID = 42061999800417;
  var GIFT_PROPERTY = '_ogc_free_gift';
  var shopRoot =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    '/';
  var thresholdPromise = null;
  var checkPromise = null;
  var queuedCheck = false;
  var monitorTimer = null;
  var originalFetch = window.fetch;

  function shopUrl(path) {
    return shopRoot.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function fetchJson(url, options) {
    return originalFetch.call(window, url, options).then(function (response) {
      if (!response.ok) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            throw new Error(
              data.description ||
                data.message ||
                'Shopify request failed (' + response.status + ').'
            );
          });
      }

      return response.json();
    });
  }

  function getLocalizedThreshold() {
    if (thresholdPromise) return thresholdPromise;

    thresholdPromise = fetchJson(
      shopUrl('products/free-gift-threshold.js'),
      {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }
    )
      .then(function (thresholdProduct) {
        var variants = thresholdProduct.variants || [];
        var selectedVariant =
          variants.find(function (variant) {
            return variant.available;
          }) || variants[0];
        var threshold = Number(selectedVariant && selectedVariant.price);

        if (!Number.isFinite(threshold) || threshold <= 0) {
          throw new Error(
            'The localized free-gift threshold is unavailable.'
          );
        }

        return threshold;
      })
      .catch(function (error) {
        thresholdPromise = null;
        throw error;
      });

    return thresholdPromise;
  }

  function getCart() {
    return fetchJson(shopUrl('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
  }

  function isGiftItem(item) {
    return Number(item.variant_id) === GIFT_VARIANT_ID;
  }

  function getGiftState() {
    return Promise.all([getCart(), getLocalizedThreshold()]).then(function (
      results
    ) {
      var cart = results[0];
      var threshold = results[1];
      var giftItems = (cart.items || []).filter(isGiftItem);
      var giftTotal = giftItems.reduce(function (total, item) {
        return total + Number(item.final_line_price || 0);
      }, 0);

      return {
        cart: cart,
        threshold: threshold,
        subtotal: Math.max(Number(cart.total_price || 0) - giftTotal, 0),
        giftItems: giftItems
      };
    });
  }

  function addGift() {
    var properties = {};
    properties[GIFT_PROPERTY] = 'true';

    return fetchJson(shopUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: properties
          }
        ]
      })
    });
  }

  function updateGiftItems(giftItems, quantity) {
    var updates = {};

    giftItems.forEach(function (item, index) {
      updates[item.key] = index === 0 ? quantity : 0;
    });

    return fetchJson(shopUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });
  }

  function dispatchGiftUpdate(state) {
    document.dispatchEvent(
      new CustomEvent('ogc:free-gift-updated', {
        detail: {
          threshold: state.threshold,
          currency: state.cart.currency
        }
      })
    );
  }

  function refreshCartDisplay() {
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    getCart()
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (
          element
        ) {
          element.textContent = cart.item_count;
        });

        document
          .querySelectorAll('[data-cart-count-bubble]')
          .forEach(function (bubble) {
            if (cart.item_count > 0) {
              bubble.classList.remove('hide');
            } else {
              bubble.classList.add('hide');
            }
          });
      })
      .catch(function (error) {
        console.error('[OGC free gift]', error);
      });
  }

  function reconcileGift(options) {
    options = options || {};

    if (window.OGCCartMutationInProgress) {
      queuedCheck = true;
      return Promise.resolve(false);
    }

    if (checkPromise) {
      queuedCheck = true;
      if (options.force) {
        return checkPromise.then(function () {
          return reconcileGift({ refresh: options.refresh, force: false });
        });
      }
      return checkPromise;
    }

    checkPromise = getGiftState()
      .then(function (state) {
        var qualifies = state.subtotal >= state.threshold;
        var giftItems = state.giftItems;
        var mutation = null;

        if (qualifies && giftItems.length === 0) {
          mutation = addGift();
        } else if (!qualifies && giftItems.length > 0) {
          mutation = updateGiftItems(giftItems, 0);
        } else if (
          qualifies &&
          giftItems.length > 0 &&
          (giftItems.length > 1 || Number(giftItems[0].quantity) !== 1)
        ) {
          mutation = updateGiftItems(giftItems, 1);
        }

        if (!mutation) {
          dispatchGiftUpdate(state);
          return false;
        }

        return mutation.then(function () {
          dispatchGiftUpdate(state);

          if (options.refresh !== false) {
            refreshCartDisplay();
          }

          return true;
        });
      })
      .catch(function (error) {
        console.error('[OGC free gift]', error);
        throw error;
      })
      .finally(function () {
        checkPromise = null;

        if (queuedCheck) {
          queuedCheck = false;
          window.setTimeout(function () {
            reconcileGift({ refresh: false });
          }, 350);
        }
      });

    return checkPromise;
  }

  function scheduleGiftCheck(manager) {
    window.clearTimeout(monitorTimer);
    monitorTimer = window.setTimeout(function () {
      if (window.OGCCartMutationInProgress) {
        scheduleGiftCheck(manager);
        return;
      }
      manager.check({ refresh: false, force: true });
    }, 450);
  }

  function monitorCartRequests(manager) {
    if (window.fetch) {
      window.fetch = function () {
        var args = arguments;
        var requestUrl =
          typeof args[0] === 'string'
            ? args[0]
            : args[0] && args[0].url
              ? args[0].url
              : '';

        return originalFetch.apply(this, args).then(function (response) {
          if (
            /\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(requestUrl)
          ) {
            scheduleGiftCheck(manager);
          }

          return response;
        });
      };
    }

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
        var requestUrl = settings && settings.url ? settings.url : '';

        if (
          /\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(requestUrl)
        ) {
          scheduleGiftCheck(manager);
        }
      });
    }
  }

  function interceptCheckout(event) {
    var checkoutButton = event.target.closest(
      '[name="checkout"], [data-ogc-checkout]'
    );

    if (!checkoutButton) return;

    if (checkoutButton.dataset.ogcProcessing === 'true') {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    checkoutButton.dataset.ogcProcessing = 'true';
    checkoutButton.disabled = true;

    reconcileGift({ refresh: false })
      .then(function () {
        window.location.assign('/checkout');
      })
      .catch(function (error) {
        console.error('[OGC free gift]', error);
        checkoutButton.dataset.ogcProcessing = 'false';
        checkoutButton.disabled = false;
      });
  }

  function init() {
    /*
     * Product and cart templates install the same localized manager before
     * this global asset loads. Reuse it instead of starting a second cart
     * watcher that can race an item-edit replacement.
     */
    if (
      window.OGCFreeGift &&
      typeof window.OGCFreeGift.check === 'function' &&
      typeof window.OGCFreeGift.getThreshold === 'function'
    ) {
      if (window.location.pathname === '/cart') {
        monitorCartRequests(window.OGCFreeGift);
      }
      return;
    }

    window.OGCFreeGift = {
      check: reconcileGift,
      getThreshold: getLocalizedThreshold,
      getState: getGiftState,
      variantId: GIFT_VARIANT_ID
    };

    monitorCartRequests(window.OGCFreeGift);
    document.addEventListener('click', interceptCheckout, true);

    reconcileGift({ refresh: false });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        reconcileGift({ refresh: false });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
